import { connect, ConnectedProps } from "react-redux";
import { IStoreState } from "../../../../reducers/types";
import { getSelectedAccountReferenceId } from "../../../rewards/reducer";
import {
  airportsSelector,
  selectedTripSelector,
  tripDetailsSelector,
} from "../../../shop/reducer/selectors";
import {
  fetchSeatMap,
  setSeatMap,
  resetPaymentCardSelectedAccounts,
  setSelectedSeats,
  setSkipSeatSelection,
  setSelectedRewardsPaymentTotal,
} from "../../actions/actions";
import {
  getCheapestSeat,
  getSeatMapAvailability,
  getPriceQuoteWithUpdatedAncillary,
  getSeatMapHtml,
  getSeatMapLoading,
  getSeatSelectionAvailability,
  getSeatsTotalPricing,
  getSeatsTotalRewardsPricing,
  getSelectedSeats,
  getSkipSeatSelection,
  getUserPassengers,
  getUserSelectedPassengerIds,
  getRewardsPaymentAccountReferenceId,
  getSelectedPaymentMethodId,
} from "../../reducer";
import { SeatSelection } from "./component";

const mapStateToProps = (state: IStoreState) => {
  const selectedTrip = selectedTripSelector(state);
  const tripId = selectedTrip.tripId || "";
  const tripDetails = tripDetailsSelector(state, tripId);
  const selectedTravelersId = getUserSelectedPassengerIds(state);
  return {
    seatMapAvailability: getSeatMapAvailability(state),
    priceQuote: getPriceQuoteWithUpdatedAncillary(state),
    seatSelectAvailability: getSeatSelectionAvailability(state),
    seatMapHtml: getSeatMapHtml(state),
    cheapestSeat: getCheapestSeat(state),
    seatMapLoading: getSeatMapLoading(state),
    selectedSeats: getSelectedSeats(state),
    tripDetails,
    passengers: getUserPassengers(state).filter((user) => {
      return selectedTravelersId.includes(user.id);
    }),
    airports: airportsSelector(state, tripId || ""),
    selectedRewardsAccountId: getSelectedAccountReferenceId(state),
    skipSeatSelection: getSkipSeatSelection(state),
    totalSeatRewards: getSeatsTotalRewardsPricing(state),
    totalSeatPricing: getSeatsTotalPricing(state),
    selectedPaymentMethodId: getSelectedPaymentMethodId(state) ?? "",
    selectedRewardsPaymentAccountId: getRewardsPaymentAccountReferenceId(state),
  };
};

const mapDispatchToProps = {
  fetchSeatMap,
  setSelectedSeats,
  setSkipSeatSelection,
  setSeatMap,
  resetPaymentCardSelectedAccounts,
  setSelectedRewardsPaymentTotal,
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export type SeatSelectionConnectorProps = ConnectedProps<typeof connector>;

export const ConnectedSeatSelection = connector(SeatSelection);
